// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"full-width_FullWidth__x413I","Article":"full-width_Article__br5NP","image":"full-width_image__hXuaD"};